import React from 'react'
import styles from './mobileCommerce.module.scss'

import {ReactComponent as IndexChart} from '../../assets/chart.svg'

const MobileCommerce = () => {
    return (
        <div className={styles.mobileCommerce}>
            <div className={`${styles.mobileCommerceWrapper} ${styles.container}`}>
                <div className={styles.aboutIndex}>
                    <h2 className={styles.title}>About this tool</h2>
                    <p>The mobile e-commerce audit tool is a free tool that was developed by e-point due to the growing demand for checking mobile readiness and friendliness of e-shops.</p>
                    <p>Scores are based on over 25 years of experience in the IT industry gathered during e-commerce audits and implementations run by e-point and Google experts.</p>
                    <p>We are giving in your hand a powerful tool to check if your e-shop is ready for mobile customers.</p>
                    <a href="https://www.e-point.com/services/mobile/mobile-audyt" className={styles.btnDecorated}>Learn more<span className={styles.srOnly}> about mobile audits</span></a>
                </div>
                <div className={styles.aboutChart}>
                    <IndexChart />
                </div>
            </div>
        </div>
    )
}

export default MobileCommerce
